import {
  PROJECTS_BLUE_COLOR_NAME,
  MARKETING_RED_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  DEV_ORANGE_COLOR_NAME
} from "styles/color-consts";

export const starsClusters = [
  {
    text: "Marketing",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/marketing_icon.png",
    colorName: MARKETING_RED_COLOR_NAME,
    position: {
      top: 185,
      left: 150
    }
  },
  {
    text: "Sales & CRM",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/crm_icon.png",
    colorName: CRM_GREEN_COLOR_NAME,
    position: {
      top: 430,
      right: 250
    }
  },
  {
    text: "Project management",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/pmo_icon.png",
    colorName: PROJECTS_BLUE_COLOR_NAME,
    position: {
      top: 410,
      left: 260
    }
  },
  {
    text: "Software development",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/dev_icon.png",
    colorName: DEV_ORANGE_COLOR_NAME,
    position: {
      top: 230,
      right: 150
    }
  },
  {
    text: "Creative & design",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/design_icon.png",
    colorName: "sofia-pink",
    position: {
      top: 55,
      left: 40
    }
  },
  {
    text: "HR",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/hr_icon.png",
    colorName: "orange",
    position: {
      top: 300,
      left: 5
    }
  },
  {
    text: "Operations",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/operations_icon.png",
    colorName: "aquamarine",
    position: {
      top: 545,
      left: 90
    }
  },
  {
    text: "IT",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/it_icon.png",
    colorName: "purple-v2",
    position: {
      top: 90,
      right: 110
    }
  },
  {
    text: "Task management",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/task_icon.png",
    colorName: "light-blue-v2",
    position: {
      top: 560,
      right: 10
    }
  }
];

export const cometLines = [
  {
    start: { top: 375, left: 545 },
    end: { top: 375, left: 680 },
    isUnderline: true
  },
  {
    start: { top: 150, left: 100 },
    end: { top: 210, left: 161 }
  },
  {
    start: { top: 515, left: 142 },
    end: { top: 450, left: 240 }
  },
  {
    start: { top: 305, left: 180 },
    end: { top: 410, left: 242 }
  },
  { start: { top: 440, left: 5 }, end: { top: 570, left: 60 } },
  { start: { top: 180, left: 1240 }, end: { top: 105, left: 1290 } },
  { start: { top: 360, left: 1140 }, end: { top: 260, left: 1190 } },
  { start: { top: 520, left: 1220 }, end: { top: 580, left: 1320 } }
];

export const stars = [
  // top left
  { top: 160, left: -129 },
  { top: 227, left: -106 },
  { top: 20, left: -20 },
  { top: 128, left: 220 },
  { top: 73, left: 315 },
  { top: 218, left: 12 },

  // middle
  { top: 50, left: 510 },
  { top: 95, left: 855 },
  { top: 449, left: 424 },
  { top: 515, left: 387 },

  // near signup
  { top: 495, left: 826 },
  { top: 487, left: 865 },
  { top: 480, left: 856 },

  // right
  { top: 24, left: 1036 },
  { top: 59, left: 1138 },
  { top: 86, left: 1087 },
  { top: 380, left: 1378 },
  { top: 202, left: 1522 }
];
